var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticStyle:{"font-size":"23px","font-weight":"bold"}},[_vm._v(_vm._s(_vm.header))]),_c('v-icon',{staticStyle:{"padding":"20px"}},[_vm._v("fas fa-caret-right")]),_c('span',{staticStyle:{"font-size":"15px"}},[_vm._v("Edit")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }